import {resolveBackground} from '#core/utils/color-utils.js';

export function matchAccaFactory(PALETTE) {
    const {FONT} = PALETTE;

    return {
        MatchAccaButton: {
            style: {
                container: {
                    ...resolveBackground(PALETTE.MATCH_ACCA_SELECTIONS_BAR_BG),
                    borderColor: PALETTE.MATCH_ACCA_SELECTIONS_BAR_BORDER_COLOR,
                    borderRadius: PALETTE.MATCH_ACCA_SELECTIONS_BAR_BORDER_RADIUS,
                    boxShadow: PALETTE.MATCH_ACCA_SELECTIONS_BAR_SHADOW,
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    // the height of container should be lower than button height, because in compact view, button is highlighted by container
                    height: 46,
                    position: 'relative',
                    widthWithOddsCalculation: 120,
                },
                oddsContainer: {
                    padding: '8px 0 0 4px',
                },
                textLabel: {
                    fontSize: 11,
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_ODDS_LABEL_TEXT,
                },
                valueLabel: {
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_ODDS_VALUE_TEXT,
                },
                errorLabel: {
                    fontSize: FONT.SIZE_MEDIUM,
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_ODDS_ERROR_VALUE_TEXT,
                },
                selectionCountContainer: {
                    ...resolveBackground(PALETTE.MATCH_ACCA_SELECTIONS_BAR_COUNTER_BUTTON_BG),
                    borderColor: PALETTE.MATCH_ACCA_SELECTIONS_BAR_COUNTER_BUTTON_BG,
                    borderRadius: '50%',
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    height: 48,
                    right: -1,
                    top: -2,
                    width: 48,
                },
                selectionCountLabel: {
                    fontSize: 20,
                    fontWeight: FONT.WEIGHT_BOLD,
                    ...PALETTE.MATCH_ACCA_SELECTIONS_BAR_COUNTER_BUTTON_TEXT,
                },
            },
        },
    };
}
